module.exports = __webpack_public_path__ + "media/components/Sponsors/Shared/Icons/post-type-13-22bfacc85fa4569b211e8402a5bacbf4.png";